import { render } from "./Formulario.vue?vue&type=template&id=f457fe20&scoped=true&ts=true"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"

import "./Formulario.vue?vue&type=style&index=0&id=f457fe20&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f457fe20"]])

export default __exports__